import React from 'react';
import styled from 'styled-components';

type Props = {
  className?: string;
  children: React.ReactNode;
};

const LiveCntBadge: React.FC<Props> = ({ className = 'LiveCnt', children }) => {
  return (
    <Container className={className}>
      <LiveCnt>{children}</LiveCnt>
    </Container>
  );
};

export default LiveCntBadge;

const Container = styled.div`
  z-index: 1;
  display: var(--talkn-livecnt-display, flex);
  align-items: center;
  justify-content: center;
  width: 50px;
  min-width: 50px;
  max-width: 50px;
  height: 50px;
  min-height: 50px;
  max-height: 50px;
  background: var(--talkn-card-bg, rgba(255, 255, 255, 1));
  border-radius: 0 50% 50% 0;
`;

const LiveCnt = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--talkn-badge-size, 30px);
  min-width: var(--talkn-badge-size, 30px);
  max-width: var(--talkn-badge-size, 30px);
  height: var(--talkn-badge-size, 30px);
  min-height: var(--talkn-badge-size, 30px);
  max-height: var(--talkn-badge-size, 30px);
  background: var(--talkn-badge-color, rgba(79, 174, 159, 0.96));
  color: var(--talkn-badge-text, #fff);
  font-size: 12px;
  border-radius: 50%;
`;
